import { Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React, { useCallback, useState } from 'react';

import Producer from './Producer';
import Product from './Product';

const styles = makeStyles(() => ({
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    ['& h1']: {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    ['& p']: {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
  buttonHeader: {
    '& a:first-child': {
      marginRight: 8,
    },
  },
  content: {
    marginTop: 16,
  },
  tabs: {},
  tab: {
    minWidth: 110,
  },
}));

type ITabs = 'producer' | 'product';

const Rating = () => {
  const classes = styles();
  const [tab, setTab] = useState<ITabs>('producer');

  const handleChange = useCallback((_: React.ChangeEvent<{}>, v: ITabs) => setTab(v), []);
  return (
    <>
      <Grid container justify='space-between'>
        <div className={classes.title}>
          <h1>Avaliações</h1>
          <p>Acompanhe as avaliações dos seus produtos e como produtor.</p>
        </div>

        <div className={classes.buttonHeader}></div>
      </Grid>

      <div className={classes.content}>
        <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
          <Tab className={classes.tab} value='producer' label='Como Produtor' />
          <Tab className={classes.tab} value='product' label='Produtos' />
        </Tabs>

        {tab === 'producer' && <Producer />}
        {tab === 'product' && <Product />}
      </div>
    </>
  );
};

export default Rating;
